import { validateStaticEnvVars } from "./env-config.schema";

/** @deprecated use publicConfig from useServices hook instead */
export const browserEnvConfig = validateStaticEnvVars({
  NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
  NEXT_PUBLIC_STATS_APP_URL: process.env.NEXT_PUBLIC_STATS_APP_URL,
  NEXT_PUBLIC_PROVIDER_PROXY_URL: process.env.NEXT_PUBLIC_PROVIDER_PROXY_URL,
  NEXT_PUBLIC_DEFAULT_NETWORK_ID: process.env.NEXT_PUBLIC_DEFAULT_NETWORK_ID,
  NEXT_PUBLIC_MASTER_WALLET_ADDRESS: process.env.NEXT_PUBLIC_MASTER_WALLET_ADDRESS,
  NEXT_PUBLIC_UAKT_TOP_UP_MASTER_WALLET_ADDRESS: process.env.NEXT_PUBLIC_UAKT_TOP_UP_MASTER_WALLET_ADDRESS,
  NEXT_PUBLIC_USDC_TOP_UP_MASTER_WALLET_ADDRESS: process.env.NEXT_PUBLIC_USDC_TOP_UP_MASTER_WALLET_ADDRESS,
  NEXT_PUBLIC_MANAGED_WALLET_NETWORK_ID: process.env.NEXT_PUBLIC_MANAGED_WALLET_NETWORK_ID,
  NEXT_PUBLIC_TRIAL_DEPLOYMENTS_DURATION_HOURS: process.env.NEXT_PUBLIC_TRIAL_DEPLOYMENTS_DURATION_HOURS,
  NEXT_PUBLIC_TRIAL_CREDITS_AMOUNT: process.env.NEXT_PUBLIC_TRIAL_CREDITS_AMOUNT,
  NEXT_PUBLIC_MANAGED_WALLET_TRIAL_MAX_CPU: process.env.NEXT_PUBLIC_MANAGED_WALLET_TRIAL_MAX_CPU,
  NEXT_PUBLIC_MANAGED_WALLET_TRIAL_MAX_MEMORY_GI: process.env.NEXT_PUBLIC_MANAGED_WALLET_TRIAL_MAX_MEMORY_GI,
  NEXT_PUBLIC_NODE_ENV: process.env.NEXT_PUBLIC_NODE_ENV,
  NEXT_PUBLIC_BASE_API_MAINNET_URL: process.env.NEXT_PUBLIC_BASE_API_MAINNET_URL,
  NEXT_PUBLIC_BASE_API_TESTNET_URL: process.env.NEXT_PUBLIC_BASE_API_TESTNET_URL,
  NEXT_PUBLIC_BASE_API_SANDBOX_URL: process.env.NEXT_PUBLIC_BASE_API_SANDBOX_URL,
  NEXT_PUBLIC_GA_MEASUREMENT_ID: process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID,
  NEXT_PUBLIC_GA_ENABLED: process.env.NEXT_PUBLIC_GA_ENABLED,
  NEXT_PUBLIC_AMPLITUDE_API_KEY: process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY,
  NEXT_PUBLIC_AMPLITUDE_ENABLED: process.env.NEXT_PUBLIC_AMPLITUDE_ENABLED,
  NEXT_PUBLIC_AMPLITUDE_PROXY_URL: process.env.NEXT_PUBLIC_AMPLITUDE_PROXY_URL,
  NEXT_PUBLIC_TURNSTILE_ENABLED: process.env.NEXT_PUBLIC_TURNSTILE_ENABLED,
  NEXT_PUBLIC_TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY,
  NEXT_PUBLIC_TRACKING_ENABLED: process.env.NEXT_PUBLIC_TRACKING_ENABLED,
  NEXT_PUBLIC_GROWTH_CHANNEL_TRACKING_ENABLED: process.env.NEXT_PUBLIC_GROWTH_CHANNEL_TRACKING_ENABLED,
  NEXT_PUBLIC_UNLEASH_ENABLE_ALL: process.env.NEXT_PUBLIC_UNLEASH_ENABLE_ALL,
  NEXT_PUBLIC_GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
  NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
  NEXT_PUBLIC_BASE_TEMPLATES_URL: process.env.NEXT_PUBLIC_BASE_TEMPLATES_URL,
  NEXT_PUBLIC_MANAGED_WALLET_TRIAL_BLOCKED_GPU_MODELS: process.env.NEXT_PUBLIC_MANAGED_WALLET_TRIAL_BLOCKED_GPU_MODELS,
  NEXT_PUBLIC_CONTACT_SUPPORT_URL: process.env.NEXT_PUBLIC_CONTACT_SUPPORT_URL
});

export type BrowserEnvConfig = typeof browserEnvConfig;
